import { Checkbox, Tooltip } from '@sib/ui';

interface GuardedTaskCheckboxProps {
  id?: string;
  checked: boolean;
  canEdit: boolean;
  disabled?: boolean;
  disabledTooltip?: string;
  className?: string;
  wrapperClassName?: string;
  'data-testid'?: string;
  onToggle?: () => void;
}

export const GuardedTaskCheckbox = ({
  id = '',
  checked,
  canEdit,
  disabled = false,
  disabledTooltip = '',
  className = '',
  wrapperClassName = '',
  'data-testid': dataTestId = '',
  onToggle,
}: GuardedTaskCheckboxProps) => {
  const isDisabled = disabled || !canEdit || !onToggle;

  const checkbox = (
    <Checkbox
      {...(id && { id })}
      {...(className && { className })}
      {...(dataTestId && { 'data-testid': dataTestId })}
      checked={checked}
      blocked={!canEdit}
      disabled={isDisabled}
      {...(canEdit && onToggle && { onCheckedChange: onToggle })}
      onClick={event => event.stopPropagation()}
    />
  );

  if (canEdit || !disabledTooltip)
    return <span className={wrapperClassName}>{checkbox}</span>;

  return (
    <Tooltip content={disabledTooltip} TooltipTriggerProps={{ asChild: true }}>
      <span className={wrapperClassName}>{checkbox}</span>
    </Tooltip>
  );
};
